import * as React from 'react';
export const searchSvg = React.forwardRef(function searchSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.579 11.816a6 6 0 1 1 1.238-1.238l3.427 3.428a.875.875 0 1 1-1.238 1.238l-3.427-3.428ZM11.25 7a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0Z',
    }),
  );
});
searchSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var search = {
  category: 'icon',
  colorable: true,
  name: 'search',
  svg: searchSvg,
};
